import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c95285f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2 dnone" }, null, -1))
const _hoisted_3 = { class: "col-1 col-sm-1 btnIzquierdo text-end" }
const _hoisted_4 = { class: "contentBtnIzq" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spanIzq" }, " < ", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "col-10 col-sm-6 text-center" }
const _hoisted_8 = { class: "backCard pr-2 bg-red" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 fw-bold titulo" }, "Fondo del vehiculo", -1))
const _hoisted_10 = { class: "fv-row mb-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("¿Que fondo deseas utilizar? "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { style: {"display":"inline-flex","list-style-type":"none","padding":"0px"} }
const _hoisted_14 = { style: {"margin-right":"10px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/bg-cars/wp-1.jpeg",
  alt: "Background Image",
  width: "280",
  height: "180"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/bg-cars/wp-2.jpeg",
  alt: "Background Image",
  width: "280",
  height: "180"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col-10 col-sm-12 text-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 fw-bold" }, "Carga las imágenes de tu vehículo (20 máx.)", -1))
const _hoisted_21 = { class: "mt-4" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1))
const _hoisted_24 = { class: "col-10" }
const _hoisted_25 = { class: "contentDropZone" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "ulImages" }
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2 dnone" }, null, -1))
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = {
  class: "containerImages",
  style: {"padding-bottom":"50px"}
}
const _hoisted_34 = { class: "listadoImagenes" }
const _hoisted_35 = {
  type: "button",
  class: "btn btn-danger btn-sm btnDerRounded btnLiTrash",
  title: "Eliminar imagen"
}
const _hoisted_36 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-primary btnIzqRounded",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevImage && _ctx.prevImage(...args)))
          }, _hoisted_6, 512), [
            [_vShow, _ctx.indexImage > 0 && _ctx.imagesThum.length > 0]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-2 border-2 hover:border-transparent rounded", _ctx.backgroundSelected === '1' ? 'border-primary' : 'border-white']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeBackground('1')))
                }, _hoisted_16, 2)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-2 border-2 hover:border-transparent rounded", _ctx.backgroundSelected === '2' ? 'border-primary' : 'border-white']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeBackground('2')))
                }, _hoisted_18, 2)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _withDirectives(_createElementVNode("input", {
          type: "file",
          name: "inputFile",
          multiple: "",
          accept: "image/*",
          id: "inputFile",
          ref: "inputFile",
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getFilesInput && _ctx.getFilesInput(...args)))
        }, null, 544), [
          [_vShow, false]
        ]),
        _hoisted_20,
        _createElementVNode("p", _hoisted_21, [
          _createTextVNode("Arrastra las imágenes de tu vehículo o "),
          _createElementVNode("span", {
            class: "spanSeleccionaImagenes",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.agregarImagenes && _ctx.agregarImagenes(...args)))
          }, "selecciona las imágenes")
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", {
              onDrop: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropEvent && _ctx.dropEvent(...args)), ["prevent"])),
              onDragenter: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkData && _ctx.checkData(...args))),
              onDragover: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.checkData && _ctx.checkData(...args))),
              class: _normalizeClass((_ctx.images.length == 0 && !_ctx.isEdit) || (_ctx.isEdit && _ctx.imagesThum.length == 0 && _ctx.images.length == 0) ? 'dropZone dzBorder' : 'dropZoneAuto')
            }, [
              _withDirectives(_createElementVNode("div", _hoisted_25, [
                _createVNode(_component_inline_svg, {
                  src: "media/icons/iconsax/gallery-add.svg",
                  height: "100",
                  width: "100",
                  class: "mb-5"
                }),
                _hoisted_26,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.agregarImagenes && _ctx.agregarImagenes(...args)))
                }, "Agregar imágenes")
              ], 512), [
                [_vShow, (_ctx.images.length == 0 && !_ctx.isEdit) || (_ctx.isEdit && _ctx.imagesThum.length == 0 && _ctx.images.length == 0)]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_27, [
                _createElementVNode("img", {
                  src: _ctx.isEdit && _ctx.imagesThum.length > 0 ? _ctx.imagesThum[_ctx.indexImage].path : _ctx.imagesThum[_ctx.indexImage],
                  class: "imgPrincipal",
                  alt: ""
                }, null, 8, _hoisted_28),
                _withDirectives(_createElementVNode("span", { class: "contadorImagenes" }, _toDisplayString(_ctx.isEdit ?
                            _ctx.imagesThum.length : _ctx.images.length) + " - 20", 513), [
                  [_vShow, _ctx.images.length > 0 || _ctx.isEdit]
                ])
              ], 512), [
                [_vShow, _ctx.images.length > 0]
              ])
            ], 34)
          ]),
          _hoisted_29
        ])
      ]),
      _hoisted_30
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("ul", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagesThum, (img, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "liAbsolute",
                key: index
              }, [
                _createElementVNode("button", _hoisted_35, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/iconsax/trash.svg",
                    class: "trashButton",
                    onClick: ($event: any) => (_ctx.eliminarImagen(index))
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("img", {
                  class: "vehiculoImagen",
                  src: _ctx.isEdit ? img.path : img,
                  alt: "Automóvil",
                  onClick: ($event: any) => (_ctx.setImage(index))
                }, null, 8, _hoisted_36)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}